/**
 * 多语言翻译
 * @param str 字符串模板，'买了个苹果，花了$ {{price}}'
 * @param data 替换数据, { price: xxx }
 * @returns str
 */
export const translate = (str: string, data: Object): string => {
  if (!str || !data) {
    return "";
  }

  Object.entries(data).forEach(([k, v]) => {
    const reg = new RegExp(`{{${k}}}`, "g");
    str = str.replace(reg, v);
  });
  return str;
};
